import styled from 'styled-components';

type InputFieldProps = {
    $gridcolumn: number;
    $gridrow: number;
};

export const AirDataContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    gap: 0.5rem 1rem;
    margin: 1rem;
`;

export const EmptyGridRow = styled.label<InputFieldProps>`
    grid-row: ${(props: InputFieldProps) => `${props.$gridrow}`};
    height: 1rem;
`;

export const InputFieldLabel = styled.label<InputFieldProps>`
    grid-column: ${(props: InputFieldProps) => `${props.$gridcolumn}`};
    grid-row: ${(props: InputFieldProps) => `${props.$gridrow}`};
    min-width: 6rem;
    display: flex;
    align-items: center;
`;

export const IconContainer = styled.span`
    display: flex;
`;

export const InputFieldContainer = styled.div<InputFieldProps>`
    grid-column: ${(props: InputFieldProps) => `${props.$gridcolumn}`};
    grid-row: ${(props: InputFieldProps) => `${props.$gridrow}`};
`;
